import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { setUser } from '@sentry/react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('token') || null); // Maneja el token

    const [userRole, setUserRole] = useState(null); // "admin", "vendedor", etc.
    const [userId, setUserId] = useState(null);
    const [userFullName, setUserFullName] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                if (!token) {
                    setUserRole(null);
                    setUserFullName(null);
                    setUserId(null)
                    setLoading(false);
                    return;
                }

                const response = await axios.get(`${import.meta.env.VITE_API_URL}/role`, {
                    headers: { 'x-auth-token': token },
                });
                
                setUserRole(response.data.role); // Ejemplo: "admin", "vendedor"
                setUserFullName(response.data.fullName); // Nombre completo del usuario
                console.log('User Full Name:', response.data.fullName);
                
                setUserId(response.data.userId)
            } catch (error) {
                console.error('Error fetching role:', error);
                setUserRole(null);
                setUserFullName(null); // Limpiar el nombre completo si hay error   
                setUserId(null)
            } finally {
                setLoading(false);
            }
        };

        fetchUserRole();
    }, [token]); // Este efecto se ejecuta cuando el token cambia


    // Función para iniciar sesión
    const login = (newToken) => {
        setToken(newToken);
        localStorage.setItem('token', newToken); // Guardar el token en localStorage
    };

    // Función para cerrar sesión
    const logout = () => {
        setToken(null);
        setUserRole(null);
        setUserId(null)
        localStorage.removeItem('token'); // Eliminar el token de localStorage
    };

    return (
        <AuthContext.Provider value={{ token, userRole, loading, login, logout, userId, fullname: userFullName }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
